<div class="c-widget--switch-account">
  <div *ngIf="affiliates.length > 5" class="c-form-field c-form-field--search c-widget--switch-account__search">
    <label class="c-form-field__inner">
      <input
        [(ngModel)]="searchName"
        type="text"
        class="c-form-field__input"
        i18n-placeholder="@@common.search_by_name"
        placeholder="Search by Name..."
      />
      <p500-ui-icon name="search c-form-field__icon"></p500-ui-icon>
    </label>
  </div>

  <div class="c-widget--switch-account__affiliates">
    <ng-container *ngFor="let affiliate of affiliates | searchFilter : 'name' : searchName">
      <div class="c-widget--switch-account__affiliates__affiliate" *ngIf="userID !== affiliate.id">
        <span p500UITooltip [tooltipData]="affiliate.name" class="c-widget--switch-account__affiliates__affiliate__name">{{
          affiliate.name
        }}</span>
        <button
          i18n="@@common.log_in"
          *ngIf="userID !== affiliate.id"
          class="c-widget--switch-account__affiliates__affiliate__login"
          (click)="login(affiliate.id)"
        >
          Log In
        </button>
      </div>
    </ng-container>
    <div *ngIf="searchName.length" class="c-widget--switch-account__affiliates__empty" i18n="@@common.no_affiliates">No Affiliates...</div>
  </div>
</div>
